export default {
  chooseSite: "CHOOSE A SITE",
  selectSite: "Select a site",
  selectedSite: "Selected Site"
};
